import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="phone-share"
export default class extends Controller {
  static values = { title: String };
  static targets = ["feedbackFlash"];

  share() {
    const report = document.getElementById("report");
    navigator
      .share({
        title: this.titleValue,
        text: report.innerText,
      })
      .then(() => {
        this.#flashFeedback();
      });
  }

  #flashFeedback() {
    const flash = this.feedbackFlashTarget.content.cloneNode(true);
    document.body.appendChild(flash);
  }
}
